import { service } from '@ember/service';
import { cached } from '@glimmer/tracking';

import type { Service } from 'webapp-types';
import { NotificationFilterType } from 'webapp/enums/notifications';

import NotificationScorecard from 'webapp/models-custom/notification/scorecard';

export default class NotificationDigest extends NotificationScorecard {
	@service('model-manager/data-selects')
	declare mmDataSelectsService: Service.ModelManager.DataSelects;
	@service('model-manager/metric-digests')
	declare mmMetricDigestsService: Service.ModelManager.MetricDigests;

	override type = NotificationFilterType.METRIC;
	override typeColor = 'var(--databox-orange-500)';
	override typeIcon: IconName = 'Metrics';
	override canToggle = true;

	@cached
	get source() {
		const ds = this.targetObject.savedDataSelects[0];
		if (ds) {
			return ds.metricSetup.source;
		}
	}

	override get subtitleText() {
		return this.source?.title || '';
	}

	override get subtitleImage() {
		return this.source?.realAvatar || '';
	}

	override get isMine() {
		return true;
	}

	override get canPreview() {
		return false;
	}

	override toggle() {
		this.mmMetricDigestsService.toggleIsActive(this.targetObject);
	}

	override delete() {
		// is always "mine"
		void this.targetObject.deleteAndCatch();
	}
}
